import { useState, useEffect, useRef } from "react";
// ─── SHEETDB CONFIG ──────────────────────────────────────────────────────────
const SHEETDB_URL = "/submit.php";

// ─── DATA ────────────────────────────────────────────────────────────────────
const PRODUK_OPTIONS = [
  "Tabungan Urban",
  "Tabungan Plan Saving",
  "Tabungan Kids Saving",
  "Tabungan Fleksi",
  "Tabungan Urban Untung",
  "Deposito Urban",
  "Kredit Multiguna",
  "Kredit Modal Kerja",
  "Kredit Investasi",
  "Kredit Back to Back",
  "Kredit Urban Sertifikasi Guru (KUR SERU)",
  "Kredit Emas",
  "KPR",
  "KPT",
  "Kredit Urban bagi Pekerja Migran Indonesia (KUR PRIMA)",
  "Kredit Kendaraan Bermotor",
  "Kredit Ultra Mikro",
];

const SUMBER_OPTIONS = [
  "Media Sosial (Instagram / TikTok / Facebook)",
  "Rekomendasi Teman / Keluarga",
  "Petugas Bank",
  "Website Bank Urban",
  "Brosur / Flyer / Billboard",
];

const RATING_ASPECTS = [
  { key: "r_keramahan", label: "Keramahan & Sikap Petugas" },
  { key: "r_kecepatan", label: "Kecepatan Proses Layanan" },
  { key: "r_kejelasan", label: "Kejelasan Informasi Produk" },
  { key: "r_kenyamanan", label: "Kenyamanan Fasilitas Kantor Pusat / Cabang" },
  { key: "r_kemudahan", label: "Kemudahan Proses & Persyaratan" },
];

const TOTAL_STEPS = 8;

// ─── STYLES ──────────────────────────────────────────────────────────────────
const styles = `
  /* IMPORT FONT POPPINS DARI GOOGLE FONTS */
  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800&display=swap');

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes scaleIn {
    from { opacity: 0; transform: scale(0.85); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50%       { transform: translateY(-14px) rotate(4deg); }
  }
  @keyframes float2 {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50%       { transform: translateY(-10px) rotate(-3deg); }
  }
  @keyframes pulse-ring {
    0%   { transform: scale(0.9); opacity: 1; }
    100% { transform: scale(1.6); opacity: 0; }
  }
  @keyframes checkDraw {
    from { stroke-dashoffset: 60; }
    to   { stroke-dashoffset: 0; }
  }

  .app-root {
    min-height: 100vh;
    background: linear-gradient(135deg, #31c2b9 0%, #68d1cc 50%, #99e1dd 100%);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
    font-family: 'Poppins', sans-serif; /* Set default font untuk seluruh aplikasi */
  }

  /* Decorative blobs */
  .blob {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
    opacity: 0.18;
  }
  .blob-1 {
    width: 420px; height: 420px;
    background: radial-gradient(circle, #fff 0%, transparent 70%);
    top: -120px; right: -80px;
    animation: float 8s ease-in-out infinite;
  }
  .blob-2 {
    width: 280px; height: 280px;
    background: radial-gradient(circle, #0e857e 0%, transparent 70%);
    bottom: -60px; left: -60px;
    animation: float2 10s ease-in-out infinite;
  }
  .blob-3 {
    width: 160px; height: 160px;
    background: radial-gradient(circle, #fff 0%, transparent 70%);
    top: 40%; left: 6%;
    animation: float 12s ease-in-out infinite reverse;
    opacity: 0.1;
  }

  /* Glass card */
  .card {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 560px;
    background: rgba(30, 138, 131, 0.85);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 24px;
    padding: 2.5rem 2.5rem 2rem;
    box-shadow: 0 24px 60px rgba(0, 80, 76, 0.4), inset 0 1px 0 rgba(255,255,255,0.3);
  }

  /* Progress bar */
  .progress-track {
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: rgba(255,255,255,0.15);
    border-radius: 24px 24px 0 0;
    overflow: hidden;
  }
  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #fff 0%, rgba(255,255,255,0.8) 100%);
    border-radius: 24px;
    transition: width 0.6s cubic-bezier(0.4,0,0.2,1);
  }

  /* Brand */
  .brand {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 2rem;
  }
  .brand-text {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 0.5px;
    font-family: 'Poppins', sans-serif;
  }
  .brand-logo-container {
    width: 52px; 
    height: 52px;
    background: white; 
    border-radius: 50%; 
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15); 
    padding: 6px; 
    flex-shrink: 0;
  }
  .brand-logo-img {
    width: 100%;
    height: 100%;
    object-fit: contain; 
  }

  /* Step label */
  .step-label {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.7);
    margin-bottom: 0.8rem;
    font-family: 'Poppins', sans-serif;
  }

  /* Question */
  .question {
    font-family: 'Poppins', sans-serif;
    font-weight: 600; /* Dibuat sedikit lebih tebal agar judul menonjol */
    font-size: 26px;
    line-height: 1.35;
    color: #ffffff;
    margin-bottom: 0.5rem;
    max-width: 420px;
  }
  .question em {
    font-style: italic;
    color: rgba(255,255,255,0.9);
  }
  .sub-text {
    font-size: 15px;
    color: rgba(255,255,255,0.8);
    margin-bottom: 1.75rem;
    line-height: 1.5;
    font-family: 'Poppins', sans-serif;
  }

  /* Slide animation */
  .slide-enter {
    animation: slideUp 0.45s cubic-bezier(0.22,1,0.36,1) forwards;
  }

  /* Inputs */
  .field-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 420px;
  }
  .input-wrap {
    position: relative;
  }
  .input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    opacity: 0.7;
    color: white;
  }
  .fu-input {
    width: 100%;
    background: rgba(255,255,255,0.15);
    border: 1.5px solid rgba(255,255,255,0.3);
    border-radius: 12px;
    padding: 14px 14px 14px 44px;
    color: #fff;
    font-size: 15px;
    font-family: 'Poppins', sans-serif;
    outline: none;
    transition: border-color 0.2s, background 0.2s;
  }
  .fu-input::placeholder { color: rgba(255,255,255,0.5); }
  .fu-input:focus {
    border-color: rgba(255,255,255,0.9);
    background: rgba(255,255,255,0.25);
  }

  /* Option buttons */
  .options-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 420px;
  }
  .opt-btn {
    background: rgba(255,255,255,0.12);
    border: 1.5px solid rgba(255,255,255,0.25);
    border-radius: 12px;
    padding: 14px 16px;
    color: rgba(255,255,255,0.9);
    font-size: 15px;
    font-family: 'Poppins', sans-serif;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .opt-btn:hover {
    background: rgba(255,255,255,0.22);
    border-color: rgba(255,255,255,0.6);
    color: #fff;
    transform: translateX(4px);
  }
  .opt-btn.selected {
    background: rgba(255,255,255,0.3);
    border-color: #ffffff;
    color: #fff;
    font-weight: 600;
  }
  .opt-check {
    width: 22px; height: 22px;
    border-radius: 50%;
    border: 1.5px solid rgba(255,255,255,0.5);
    display: flex; align-items: center; justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
    transition: all 0.2s;
  }
  .opt-btn.selected .opt-check {
    background: white;
    border-color: white;
    color: #1e8a83;
    font-weight: 800;
  }

  /* Rating stars */
  .rating-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 420px;
  }
  .rating-row {
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .rating-lbl {
    font-size: 14px;
    color: #ffffff;
    flex: 1;
    font-family: 'Poppins', sans-serif;
  }
  .stars-row {
    display: flex;
    gap: 4px;
  }
  .star-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 26px;
    line-height: 1;
    padding: 2px;
    transition: transform 0.15s;
    color: rgba(255,255,255,0.3);
  }
  .star-btn:hover { transform: scale(1.25); }
  .star-btn.lit { color: #FFD700; }

  /* NPS Slider */
  .slider-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1.5rem 0 2rem;
    width: 100%;
    max-width: 420px;
  }
  .slider-value-display {
    font-size: 56px;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1.5rem;
    text-shadow: 0 4px 16px rgba(0,0,0,0.25);
    background: rgba(255,255,255,0.15);
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    border: 1px solid rgba(255,255,255,0.3);
    box-shadow: inset 0 2px 10px rgba(255,255,255,0.1);
  }
  .nps-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: rgba(255,255,255,0.25);
    outline: none;
    margin: 1rem 0;
  }
  .nps-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    border: 4px solid #167a74;
    transition: transform 0.15s;
  }
  .nps-slider::-webkit-slider-thumb:hover {
    transform: scale(1.15);
  }
  .nps-slider::-moz-range-thumb {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    border: 4px solid #167a74;
  }
  .nps-hint {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    font-size: 13px;
    color: rgba(255,255,255,0.8);
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }

  /* Textarea */
  .fu-textarea {
    width: 100%;
    max-width: 420px;
    background: rgba(255,255,255,0.15);
    border: 1.5px solid rgba(255,255,255,0.3);
    border-radius: 12px;
    padding: 15px;
    color: #fff;
    font-size: 15px;
    font-family: 'Poppins', sans-serif;
    line-height: 1.65;
    resize: none;
    min-height: 120px;
    outline: none;
    transition: border-color 0.2s, background 0.2s;
  }
  .fu-textarea::placeholder { color: rgba(255,255,255,0.5); }
  .fu-textarea:focus {
    border-color: rgba(255,255,255,0.9);
    background: rgba(255,255,255,0.25);
  }

  /* Navigation */
  .nav-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 1.8rem;
  }
  .btn-back {
    background: transparent;
    border: 1.5px solid rgba(255,255,255,0.35);
    color: rgba(255,255,255,0.9);
    border-radius: 10px;
    padding: 12px 18px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    transition: all 0.2s;
    display: flex; align-items: center; gap: 6px;
  }
  .btn-back:hover {
    border-color: #ffffff;
    color: #fff;
    background: rgba(255,255,255,0.1);
  }
  .btn-next {
    background: white;
    border: none;
    color: #167a74;
    border-radius: 10px;
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    transition: all 0.2s;
    display: flex; align-items: center; gap: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  }
  .btn-next:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.25);
  }
  .btn-next:active { transform: scale(0.97); }
  .btn-next-lg {
    padding: 14px 30px;
    font-size: 16px;
    border-radius: 12px;
  }
  .btn-submit {
    background: linear-gradient(135deg, #fff 0%, #e0faf9 100%);
  }

  /* Error */
  .err {
    font-size: 13px;
    color: #ffebcc;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
    animation: fadeIn 0.2s;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }

  /* Intro slide */
  .intro-tag {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,0.2);
    border: 1px solid rgba(255,255,255,0.35);
    border-radius: 999px;
    padding: 6px 16px;
    font-size: 13px;
    color: #ffffff;
    margin-bottom: 1.2rem;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }
  .intro-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 32px;
    line-height: 1.3;
    color: #fff;
    margin-bottom: 1rem;
  }
  .intro-title em {
    font-style: italic;
    color: rgba(255,255,255,0.9);
  }
  .intro-body {
    font-size: 15px;
    color: rgba(255,255,255,0.85);
    line-height: 1.7;
    max-width: 380px;
    margin-bottom: 2rem;
    font-family: 'Poppins', sans-serif;
  }
  .time-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.15);
    border-radius: 8px;
    padding: 5px 12px;
    font-size: 13px;
    color: rgba(255,255,255,0.9);
    margin-bottom: 2rem;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }

  /* Finish slide */
  .finish-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1rem 0;
  }
  .check-circle {
    position: relative;
    width: 80px; height: 80px;
    margin-bottom: 1.8rem;
  }
  .check-ring {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(255,255,255,0.4);
    animation: pulse-ring 1.5s ease-out infinite;
  }
  .check-svg {
    position: relative;
    z-index: 1;
  }
  .finish-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 28px;
    color: #fff;
    margin-bottom: 0.75rem;
    line-height: 1.35;
  }
  .finish-body {
    font-size: 15px;
    color: rgba(255,255,255,0.85);
    line-height: 1.7;
    max-width: 360px;
    margin-bottom: 1.5rem;
    font-family: 'Poppins', sans-serif;
  }
  .finish-team {
    font-size: 14px;
    color: rgba(255,255,255,0.6);
    margin-top: 0.8rem;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }
  .finish-divider {
    width: 48px;
    height: 2px;
    background: rgba(255,255,255,0.3);
    margin: 1.2rem auto;
  }

  /* Submitting state */
  .submitting-dot {
    display: inline-block;
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #167a74;
    margin: 0 2px;
    animation: bounce 1s infinite ease-in-out;
  }
  .submitting-dot:nth-child(2) { animation-delay: 0.2s; }
  .submitting-dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes bounce {
    0%,100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }

  /* Footer */
  .footer {
    position: relative; z-index: 1;
    margin-top: 1.5rem;
    font-size: 12px;
    color: rgba(255,255,255,0.6);
    text-align: center;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }
`;

// ─── HELPERS ─────────────────────────────────────────────────────────────────
function StarRating({ value, onChange }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="stars-row">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          className={`star-btn${n <= (hover || value) ? " lit" : ""}`}
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
        >
          ★
        </button>
      ))}
    </div>
  );
}

function OptionList({ options, value, onChange }) {
  return (
    <div className="options-list">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`opt-btn${value === opt ? " selected" : ""}`}
          onClick={() => onChange(opt)}
        >
          <span className="opt-check">{value === opt ? "✓" : ""}</span>
          {opt}
        </button>
      ))}
    </div>
  );
}

function ErrorMsg({ msg }) {
  return msg ? <p className="err">⚠ {msg}</p> : null;
}

// ─── SLIDES ──────────────────────────────────────────────────────────────────
function SlideIntro({ onNext }) {
  return (
    <div className="slide-enter">
      <div className="intro-tag">✦ Formulir Penilaian</div>
      <h1 className="intro-title">
        Bagaimana pengalaman Anda bersama kami?
      </h1>
      <div className="time-badge">⏱ Hanya butuh 2–3 menit</div>
      <p className="intro-body">
        Setiap masukan Anda adalah cermin bagi kami untuk terus berbenah.
        Terima kasih telah mempercayai PT. BPR Urban Bali sebagai mitra keuangan Anda.
      </p>
      <button className="btn-next btn-next-lg" onClick={onNext}>
        Mulai Sekarang <span>→</span>
      </button>
    </div>
  );
}

function SlideNama({ value, onChange, onNext, onBack }) {
  const [err, setErr] = useState("");
  const ref = useRef(null);
  useEffect(() => { ref.current?.focus(); }, []);

  const handle = () => {
    if (!value.trim()) { setErr("Mohon masukkan nama Anda"); return; }
    setErr(""); onNext();
  };

  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 1 dari 7</div>
      <h2 className="question">Siapa nama Anda?</h2>
      <p className="sub-text">Untuk meningkatkan kenyamanan pelayanan, mohon masukkan nama lengkap Anda.</p>
      <div className="field-group">
        <div className="input-wrap">
          <span className="input-icon">👤</span>
          <input
            ref={ref}
            type="text"
            className="fu-input"
            placeholder="Nama lengkap Anda"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handle()}
          />
        </div>
        <ErrorMsg msg={err} />
      </div>
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideKontak({ email, telp, onChangeEmail, onChangeTelp, onNext, onBack }) {
  const [err, setErr] = useState("");
  const handle = () => {
    if (!email.trim() || !telp.trim()) { setErr("Mohon isi email dan nomor telepon"); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setErr("Format email tidak valid"); return; }
    setErr(""); onNext();
  };
  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 2 dari 7</div>
      <h2 className="question">Informasi kontak Anda</h2>
      <p className="sub-text">Data ini membantu kami untuk memberikan solusi terbaik jika masukan Anda memerlukan tindak lanjut khusus dari tim layanan kami.</p>
      <div className="field-group">
        <div className="input-wrap">
          <span className="input-icon">✉️</span>
          <input
            type="email"
            className="fu-input"
            placeholder="Alamat email"
            value={email}
            onChange={(e) => onChangeEmail(e.target.value)}
          />
        </div>
        <div className="input-wrap">
          <span className="input-icon">📱</span>
          <input
            type="tel"
            className="fu-input"
            placeholder="Nomor telepon"
            value={telp}
            onChange={(e) => onChangeTelp(e.target.value)}
          />
        </div>
        <ErrorMsg msg={err} />
      </div>
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideProduk({ value, onChange, onNext, onBack }) {
  const [err, setErr] = useState("");
  const handle = () => {
    if (!value) { setErr("Mohon pilih produk yang digunakan"); return; }
    setErr(""); onNext();
  };
  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 3 dari 7</div>
      <h2 className="question">Produk apa yang baru Anda buka?</h2>
      <p className="sub-text">Pilih satu produk yang baru saja Anda daftarkan</p>
      <OptionList options={PRODUK_OPTIONS} value={value} onChange={onChange} />
      <ErrorMsg msg={err} />
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideSumber({ value, onChange, onNext, onBack }) {
  const [err, setErr] = useState("");
  const handle = () => {
    if (!value) { setErr("Mohon pilih salah satu"); return; }
    setErr(""); onNext();
  };
  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 4 dari 7</div>
      <h2 className="question">Dari mana Anda mengetahui Bank Urban?</h2>
      <p className="sub-text">Pilih satu yang paling utama</p>
      <OptionList options={SUMBER_OPTIONS} value={value} onChange={onChange} />
      <ErrorMsg msg={err} />
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideRating({ ratings, onChange, onNext, onBack }) {
  const [err, setErr] = useState("");
  const handle = () => {
    const allFilled = RATING_ASPECTS.every((a) => ratings[a.key] > 0);
    if (!allFilled) { setErr("Mohon berikan penilaian untuk semua aspek"); return; }
    setErr(""); onNext();
  };
  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 5 dari 7</div>
      <h2 className="question">Bagaimana penilaian Anda terhadap layanan kami?</h2>
      
      {/* Jarak bawah diperkecil agar menyatu dengan disclaimer */}
      <p className="sub-text" style={{ marginBottom: "0.5rem" }}>
        1 bintang = Sangat Buruk &nbsp;|&nbsp; 5 bintang = Sangat Baik
      </p>
      
      {/* Teks Disclaimer Baru */}
      <p style={{ 
        fontSize: "13px", 
        color: "rgba(255,255,255,0.6)", 
        fontFamily: "'Poppins', sans-serif", 
        marginBottom: "1.75rem", 
        lineHeight: "1.5" 
      }}>
        *Mohon berikan penilaian secara jujur. Data Anda bersifat rahasia, tidak memengaruhi layanan rekening Anda, dan murni digunakan untuk evaluasi internal.
      </p>

      <div className="rating-list">
        {RATING_ASPECTS.map((a) => (
          <div className="rating-row" key={a.key}>
            <span className="rating-lbl">{a.label}</span>
            <StarRating
              value={ratings[a.key] || 0}
              onChange={(v) => onChange(a.key, v)}
            />
          </div>
        ))}
      </div>
      <ErrorMsg msg={err} />
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideNPS({ value, onChange, onNext, onBack }) {
  const displayValue = value > 0 ? value : 1;

  const handleSliderChange = (e) => {
    onChange(parseInt(e.target.value, 10));
  };

  const handle = () => {
    if (value < 0) {
      onChange(5);
    }
    onNext();
  };

  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 6 dari 7</div>
      <h2 className="question">Seberapa besar kemungkinan Anda merekomendasikan Bank Urban kepada orang lain?</h2>
      
      <p className="sub-text">Geser titik di bawah ini untuk memberikan penilaian Anda</p>
      
      <div className="slider-wrap">
        <div className="slider-value-display">
          {displayValue}
        </div>
        
        <input 
          type="range" 
          min="1" 
          max="10" 
          step="1" 
          value={displayValue} 
          onChange={handleSliderChange}
          className="nps-slider"
        />
        
        <div className="nps-hint">
          <span>1 - Sangat Tidak Mungkin</span>
          <span>10 - Pasti Merekomendasikan</span>
        </div>
      </div>

      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button className="btn-next" onClick={handle}>Lanjut →</button>
      </div>
    </div>
  );
}

function SlideSaran({ value, onChange, onSubmit, onBack, submitting }) {
  return (
    <div className="slide-enter">
      <div className="step-label">Langkah 7 dari 7</div>
      <h2 className="question">Suara Anda, Prioritas Kami</h2>
      <p className="sub-text">Apakah ada hal lain yang ingin Bapak/Ibu sampaikan terkait layanan kami? Jangan ragu untuk menuliskan saran atau masukan Anda pada kolom di bawah ini.</p>
      <textarea
        className="fu-textarea"
        placeholder="Ceritakan pengalaman Anda di sini..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={5}
      />
      <div className="nav-row">
        <button className="btn-back" onClick={onBack}>← Kembali</button>
        <button
          className="btn-next btn-next-lg btn-submit"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? (
            <>
              Mengirim
              <span className="submitting-dot" />
              <span className="submitting-dot" />
              <span className="submitting-dot" />
            </>
          ) : (
            "Kirim ✓"
          )}
        </button>
      </div>
    </div>
  );
}

function SlideFinish() {
  return (
    <div className="slide-enter finish-wrap">
      <div className="check-circle">
        {/* Ring animasi luar kita beri warna hijau agar senada */}
        <div className="check-ring" style={{ borderColor: "#4CAF50" }} />
        <svg className="check-svg" width="80" height="80" viewBox="0 0 72 72" fill="none">
          {/* Lingkaran warna hijau solid dengan border hijau muda (seperti di gambar) */}
          <circle 
            cx="36" cy="36" r="32" 
            fill="#4CAF50" 
            stroke="#A5D6A7" 
            strokeWidth="6" 
          />
          {/* Garis centang putih yang ukurannya dipertebal */}
          <polyline
            points="24,37 32,45 49,28"
            fill="none"
            stroke="white"
            strokeWidth="5.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="60"
            strokeDashoffset="0"
            style={{ animation: "checkDraw 0.6s ease 0.2s both" }}
          />
        </svg>
      </div>
      <h2 className="finish-title">Terima Kasih atas<br />Partisipasi Anda</h2>
      <div className="finish-divider" />
      <p className="finish-body">
        Penilaian Anda telah berhasil kami terima. Masukan yang Anda berikan
        akan menjadi landasan kami dalam menghadirkan layanan yang lebih baik,
        lebih cepat, dan lebih bermakna bagi seluruh nasabah Bank Urban.
      </p>
      <p style={{ fontSize: 16, color: "rgba(255,255,255,0.9)", fontStyle: "italic", fontFamily: "'Poppins', sans-serif" }}>
        "Kami Ada, Karena Anda."
      </p>
      <p className="finish-team">— Tim Bank Urban</p>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    nama: "",
    email: "",
    telp: "",
    produk: "",
    sumber: "",
    ratings: { r_keramahan: 0, r_kecepatan: 0, r_kejelasan: 0, r_kenyamanan: 0, r_kemudahan: 0 },
    nps: -1,
    saran: "",
  });

  const update = (field, val) => setForm((f) => ({ ...f, [field]: val }));
  const updateRating = (key, val) =>
    setForm((f) => ({ ...f, ratings: { ...f.ratings, [key]: val } }));

  const goNext = () => setStep((s) => s + 1);
  const goBack = () => setStep((s) => s - 1);

  const progress = step === 0 ? 0 : (step / (TOTAL_STEPS)) * 100;

  const handleSubmit = async () => {
  setSubmitting(true);
  const now = new Date();
  const timestamp = now.toLocaleString("id-ID", { timeZone: "Asia/Makassar" });

  const payload = {
    data: [
      {
        Timestamp: timestamp,
        Nama: form.nama,
        Email: form.email,
        "No. Telepon": form.telp,
        Produk: form.produk,
        "Sumber Informasi": form.sumber,
        "Rating Keramahan": form.ratings.r_keramahan,
        "Rating Kecepatan": form.ratings.r_kecepatan,
        "Rating Kejelasan": form.ratings.r_kejelasan,
        "Rating Kenyamanan": form.ratings.r_kenyamanan,
        "Rating Kemudahan": form.ratings.r_kemudahan,
        "NPS Score": form.nps,
        "Saran & Masukan": form.saran,
      }
    ],
  };

  try {
    const res = await fetch(SHEETDB_URL, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json", 
        "Accept": "application/json" 
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json(); 
    
    if (!res.ok) {
      throw new Error(result.error || "SheetDB error");
    }

    setSubmitting(false);
    goNext();
    
  } catch (err) {
    setSubmitting(false);
    alert("Terjadi kesalahan saat mengirim data. Silakan coba lagi.");
  }
};

  const slides = [
    <SlideIntro onNext={goNext} />,
    <SlideNama value={form.nama} onChange={(v) => update("nama", v)} onNext={goNext} onBack={goBack} />,
    <SlideKontak
      email={form.email} telp={form.telp}
      onChangeEmail={(v) => update("email", v)}
      onChangeTelp={(v) => update("telp", v)}
      onNext={goNext} onBack={goBack}
    />,
    <SlideProduk value={form.produk} onChange={(v) => update("produk", v)} onNext={goNext} onBack={goBack} />,
    <SlideSumber value={form.sumber} onChange={(v) => update("sumber", v)} onNext={goNext} onBack={goBack} />,
    <SlideRating ratings={form.ratings} onChange={updateRating} onNext={goNext} onBack={goBack} />,
    <SlideNPS value={form.nps} onChange={(v) => update("nps", v)} onNext={goNext} onBack={goBack} />,
    <SlideSaran value={form.saran} onChange={(v) => update("saran", v)} onSubmit={handleSubmit} onBack={goBack} submitting={submitting} />,
    <SlideFinish />,
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="app-root">
        {/* Decorative blobs */}
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />

        <div className="card">
          {/* Progress bar */}
          {step > 0 && step < slides.length - 1 && (
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${progress}%` }} />
            </div>
          )}

          {/* Brand header */}
          <div className="brand">
            <div className="brand-logo-container">
              <img 
                src="/logo.png" 
                alt="Logo Bank Urban" 
                className="brand-logo-img" 
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="brand-text" style={{ fontSize: '16px', marginBottom: '2px' }}>Bank Urban</span>
              <span className="brand-text" style={{ fontSize: '11px', opacity: 0.8, fontWeight: 500 }}>PT. BPR URBAN BALI</span>
            </div>
          </div>
          {/* Active slide */}
          <div key={step}>{slides[step]}</div>
        </div>

        <p className="footer">© {new Date().getFullYear()} PT. BPR URBAN BALI · Formulir Penilaian Layanan</p>
      </div>
    </>
  );
}